<template>
  <div class="itemBox">
    <div class="imgBlock">
      <img class="itemImg" src="~@/assets/img/scan_coupon_small.png" />
    </div>
    <div class="informBlock">
      <div class="headerBlock">
        <div class="itemName text">
          {{ name }}
        </div>
        <div class="itemAction">
          <div class="itemPrice">
            {{ price }}
          </div>
        </div>
      </div>
    </div>
    <div class="editRemoveBlock">
      <remove-button @remove="clearCoupons" />
    </div>
  </div>
</template>
<script>
import { COUPON_CATEGORIES, toPrintable } from "@/utils/pricing";
import { mapGetters, mapMutations } from "vuex";
import RemoveButton from "@/components/order/listItems/common/removeButton.vue";

export default {
  name: "CouponItem",
  components: { RemoveButton },
  computed: {
    ...mapGetters({ basket: "BASKET", coupons: "COUPONS" }),
    name() {
      if (this.coupon.data.c === COUPON_CATEGORIES.AMOUNT_OFF) {
        let amount = toPrintable(-1 * this.coupon.data.a);
        return `Coupon (${amount}€ ${this.$t("order.discount")})`;
      }
      if (this.coupon.data.c === COUPON_CATEGORIES.PERCENT_OFF) {
        let amount = parseInt(Math.round(this.coupon.data.a));
        return `Coupon (${amount}% ${this.$t("order.discount")})`;
      }
      return "Coupon";
    },
    price() {
      if (this.coupon.data.c === COUPON_CATEGORIES.AMOUNT_OFF) {
        return toPrintable(-1 * this.coupon.data.a);
      }
      if (this.coupon.data.c === COUPON_CATEGORIES.PERCENT_OFF) {
        return this.basket.vatDetails.grossBaseDiscount.toPrintable();
      }
      return 0.0;
    }
  },
  methods: {
    toPrintable,
    del() {
      this.$emit("del", this.coupon);
    },
    ...mapMutations({
      clearCoupons: "CLEAR_COUPONS"
    })
  },
  props: {
    coupon: Object
  }
};
</script>

<style scoped>
.itemImg {
  height: 130px;
  object-fit: contain;
}
.imgBlock {
  flex: 0 0 25%;
  justify-content: center;
  display: flex;
}
.informBlock {
  width: 72%;
}
.headerBlock {
  display: flex;
  justify-content: space-between;
}
.itemAction {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.itemName {
  margin-top: 30px;
  color: #62a200;
  font-family: var(--app_font-family_regular);
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 1.1px;
}

.itemPrice {
  width: var(--component_order_listitems_CouponItem_itemPrice_width);
  justify-content: flex-end;
  font-family: var(
    --component_order_listitems_CouponItem_itemPrice_font-family
  );
  color: #3d3d3d;
  font-size: 22px;
  display: flex;
  align-items: var(
    --component_order_listitems_CouponItem_itemPrice_align-items
  );
  padding-right: 10px;
  flex-direction: column;
}
</style>
